<template>
    <div>
        <div class="w-100 d-flex justify-content-center" v-if="whitelabel.preview">
            <img class="rounded-circle" width="110" height="110" :src="whitelabel.preview" alt="" >
        </div>

        <svg class="w-100" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 35.378 39.315" v-else>
            <g id="Grupo_69" data-name="Grupo 69" transform="translate(-481.81 380)">
                <g id="Grupo_68" data-name="Grupo 68" transform="translate(481.81 -380)">
                    <rect id="Retângulo_39" data-name="Retângulo 39" width="5.56" height="22.238"
                            transform="translate(31.447 19.656) rotate(45)" fill="#00dbf9"></rect>
                    <path id="Caminho_94" data-name="Caminho 94"
                            d="M509.329-372.137l-3.931-3.931L501.466-380l-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931,3.931,7.863,7.863,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931Zm-11.794,11.794-3.931,3.931-3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931Z"
                            transform="translate(-481.81 380)" fill="#3839e3"></path>
                    <rect id="Retângulo_40" data-name="Retângulo 40" width="5.56" height="11.119"
                            transform="translate(11.792 31.453) rotate(-45)" fill="#0195ff"></rect>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        organization:{
            default: null
        }
    },
    data() {
        return{
            whitelabel: null
        }
    },
    created() {
        this.whitelabel = this.organization
    }
}
</script>

<style>

</style>
